import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { IMemebersViewModel, IMemebersInputModel, IEipUserModel } from 'src/app/ViewModel/MembersModel';
import { RestApiService } from 'src/app/Service/rest-api.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { CommonService } from 'src/app/Service/Common.service';

export enum PageIcons {
    Members,
    RespondWorkFlow
}
// export interface IconsSpec {
//     Name: string ,
//     IsAllow: boolean
//     class :  string
//     title:  string

// }

// export interface  KendoUIOutputModel
// {
//       MemberID : number ,
//       MenuId  : number ,
//       order  : number ,
//       width   : number ,
//       field  : string ,
//       title      : string 
// }

// export interface  KendoUIinputModel
// {
//       MemberID : number ,
//       MenuId  : number ,
//       JsonData : string
// }
@Injectable({
    providedIn: 'root'
})
export class DynamickendoService {

    private GetGridSettingsUrl = 'Menu/GetGridSettings';
    private PostGridSettingsUrl = 'Menu/PostGridSettings';
    PIcons!: PageIcons;
    MemberId!: number;
    constructor(private restAPTService: RestApiService, private CommonService: CommonService, private _notificationService: NotificationService) { }


    /**
     * Get Members List API
     * @param member_Id 50
     * @param company_Code 50
     */
    public GetGridSettings(url: string): Observable<any[]> {
        let obj = this.ConstructGridObject(url);
        return this.restAPTService.new_POST(this.GetGridSettingsUrl, obj);
    }

    /**
     * Insert and Update Member Details 
     * @param memberDetails 
     */
    public PostGridSettings(input: any): Observable<any> {

        return this.restAPTService.new_POST(this.PostGridSettingsUrl, input);
    }




    gridSettings(obj: any, url: string) {

        let columnList: any = this.ConstructGridObject(url, obj);
        this.PostGridSettings(columnList).subscribe((res: StandardOutputModel) => {
            if (res.successCode == 200) {

                this._notificationService.showToast(res.successMessage, "Success");
            }
            else {

            }
        }, err => {

        });;
    }

    public ConstructGridObject(url: string, input?: any): any {
        this.MemberId = this.CommonService.getLoggedInUserId();
        let Menu = JSON.parse(this.CommonService.getSessionStorageItem("Menu"));
        let _MenuId!: number;
        let _JsonData: string = "";
        let _Sort :string = "";
        url = url.substring(1, url.length);
        let _urlobj = url.split("/");
        if (Menu && Menu.length > 0 && _urlobj.length > 0) {
            Menu.forEach((element: any) => {
                if (element.childList && element.childList.length > 0 && element.childList.some((x: { menuUrl: string; }) => x.menuUrl.toUpperCase().trim() == url.toUpperCase().trim())) 
                    _MenuId = element.childList.filter((x: { menuUrl: string; }) => x.menuUrl.toUpperCase().trim() == url.toUpperCase().trim())[0].menuCode
                   
            });
        }
        if(!_MenuId && Menu.some((y: { menuUrl: string; })=>y.menuUrl.toUpperCase().trim() == url.toUpperCase().trim()))
        {
            _MenuId =  Menu.filter((y: { menuUrl: string; })=>y.menuUrl.toUpperCase().trim() == url.toUpperCase().trim())[0].menuCode;
        }
        // only for Save grid settings
        if (input) {
            let settingsObject: any[] = [];
            if (input && input.first.columnList.columns._results) {
                input.first.columnList.columns._results.forEach((element:any) => {


                    settingsObject.push({
                        order: element.leafIndex,
                        width: element._width,
                        field: element.field,
                        title: element.title

                    });

                });
                settingsObject = settingsObject.sort((a, b) => a.order - b.order);
                settingsObject = settingsObject.filter(x => x.field);
                _JsonData = JSON.stringify(settingsObject)

            }
            if(input._results[0]._sort)
                _Sort =  JSON.stringify(input._results[0]._sort);
        }

        let obj: any = {
            MemberID: this.MemberId,
            MenuId: _MenuId,
            JsonData: _JsonData,
            ProjectId:this.CommonService.getProjectId(),
            GroupId : this.CommonService.getLoggedInUserGroupId(),
            Sort : _Sort
        }
        return obj
    }

    public getIcondetails(data: PageIcons): any[] {

        switch (data) {
            case PageIcons.Members:
                return [{ Name: "Edit", IsAllow: true, class: "fa fa-pencil icon-my-10", title: "Edit Member", Isheader: false, Istoogle: false },
                { Name: "Unlock", IsAllow: true, class: "fa fa-unlock icon-my-10", title: "Unlock", Isheader: false, Istoogle: false },
                { Name: "Add Member", IsAllow: true, class: "fa fa-plus-circle icon-my-10", title: "Add Member", Isheader: true, Istoogle: false },
                ];
            case PageIcons.RespondWorkFlow:
                return [{ Name: "Edit", IsAllow: true, class: "fa fa-pencil icon-my-10", title: "Test Edit Member" }];

        }
    }

} 